import { useState, useEffect } from "react";
import { show_alerta } from '../../funciones.js';

function UsuarioCrudForm({crearData, actualizarData, datoAEditar, setDatoAEditar}){
    
    const inicialForm ={
        id:null,
        usuario:"",
        clave:'',
        nombre:"",
        apellido:"",
        documento:"",
        fecnac:"",
        genero:"",
        email:"",
        telefono:"",
        calle:"",
        numero:"",
        piso:"",
        depto:"",
        ciudad:"",
        provincia:""
    };
    
    const [form, setForm] = useState(inicialForm)

    useEffect(()=>{
        if(datoAEditar){
            setForm(datoAEditar);
        }else{
            setForm(inicialForm);
        }
    },[datoAEditar])

    const handleChange =(e) => {
        setForm({
        ...form,
            [e.target.name]: e.target.value    
        })
    }

    const handleSubmint =(e) => {
        e.preventDefault();

        if(!form.usuario || !form.nombre || !form.apellido || !form.documento ){
            show_alerta('faltan datos ','error');
            return;
        }
         
        if(form.id == null){
            crearData(form);
        }else{
            actualizarData(form);
            
        }
        handleReset(e);
    }

    const handleReset =(e) => {
        setForm(inicialForm);
        setDatoAEditar(null);
        console.log('reset')
    }

    return(
        <div>
            <h3>{datoAEditar ? "Editar" : "Agregar Nuevo"}</h3>
            <form onSubmit={handleSubmint}>

                <input type='hidden' id='id' />
                <div className='input-group m-3'>
                    <span className='input-group-text'><i className='fa-regular fa-id-badge'></i></span>
                    <input type="text" className="form-control"
                     name="usuario" 
                    placeholder="Nombre de usuario" 
                    value={form.usuario} 
                    onChange={handleChange} 
                   
                    />
                </div>
                { datoAEditar==null ? ( 
                <div className='input-group m-3'>
                    <span className='input-group-text'><i className='fa-solid fa-key'></i></span>
                    <input type="password" className="form-control"
                    name="clave" 
                    placeholder="contraseña" 
                    onChange={handleChange} 
                    value={form.clave} 
                    />
                </div>
                ):""
                }
                <div className='input-group m-3'>
                    <span className='input-group-text'><i className='fa-solid fa-user'></i></span>
                    <input type="text" className="form-control"
                     name="nombre" 
                    placeholder="Nombre" 
                    onChange={handleChange} 
                    value={form.nombre} 
                    />
                </div>                    
                <div className='input-group m-3'>
                    <span className='input-group-text'><i className='fa-solid fa-user'></i></span>
                    <input type="text" className="form-control"
                    name="apellido" 
                    placeholder="Apellido" 
                    onChange={handleChange} 
                    value={form.apellido} 
                    />
                </div>
                <div className='input-group m-3'>
                    <span className='input-group-text'><i className='fa-regular fa-id-card'></i></span>
                    <input type="text" className="form-control"
                    name="documento" 
                    placeholder="Documento" 
                    onChange={handleChange} 
                    value={form.documento} 
                    />
                </div>
                
                <div className='row m-2'>
                    <div className='col-md-6 mb-2'>
                        <div className='input-group'>
                            <span className='input-group-text'><i className='fa-solid fa-calendar'></i></span>
                            <input type="date" className="form-control" name="fecnac" placeholder="Nacimiento" onChange={handleChange} value={form.fecnac || ''} />
                        </div>
                    </div>
                    <div className='col-md-6 mb-2'>
                        <div className='input-group'>
                            <span className='input-group-text'><i className='fa-solid fa-venus-mars'></i></span>
                            <input type="text" className="form-control" name="genero" placeholder="Género" onChange={handleChange} value={form.genero || ''} />
                        </div>
                    </div>
                    <div className='col-md-6 mb-2'>
                        <div className='input-group'>
                            <span className='input-group-text'><i className='fa-solid fa-envelope'></i></span>
                            <input type="email" className="form-control" name="email" placeholder="Email" onChange={handleChange} value={form.email || ''} />
                        </div>
                    </div>
                    <div className='col-md-6 mb-2'>
                        <div className='input-group'>
                            <span className='input-group-text'><i className='fa-solid fa-phone'></i></span>
                            <input type="text" className="form-control" name="telefono" placeholder="Teléfono" onChange={handleChange} value={form.telefono || ''} />
                        </div>
                    </div>
                    <div className='col-md-8 mb-2'>
                        <div className='input-group'>
                            <span className='input-group-text'><i className='fa-solid fa-road'></i></span>
                            <input type="text" className="form-control" name="calle" placeholder="Calle" onChange={handleChange} value={form.calle || ''} />
                        </div>
                    </div>
                    <div className='col-md-4 mb-2'>
                        <div className='input-group'>
                            <span className='input-group-text'>N°</span>
                            <input type="text" className="form-control" name="numero" placeholder="Número" onChange={handleChange} value={form.numero || ''} />
                        </div>
                    </div>
                    <div className='col-md-6 mb-2'>
                        <div className='input-group'>
                            <span className='input-group-text'>Piso</span>
                            <input type="text" className="form-control" name="piso" placeholder="Piso" onChange={handleChange} value={form.piso || ''} />
                        </div>
                    </div>
                    <div className='col-md-6 mb-2'>
                        <div className='input-group'>
                            <span className='input-group-text'>Dpto</span>
                            <input type="text" className="form-control" name="depto" placeholder="Depto" onChange={handleChange} value={form.depto || ''} />
                        </div>
                    </div>
                    <div className='col-md-6 mb-2'>
                        <div className='input-group'>
                            <span className='input-group-text'><i className='fa-solid fa-city'></i></span>
                            <input type="text" className="form-control" name="ciudad" placeholder="Ciudad" onChange={handleChange} value={form.ciudad || ''} />
                        </div>
                    </div>
                    <div className='col-md-6 mb-2'>
                        <div className='input-group'>
                            <span className='input-group-text'><i className='fa-solid fa-map-location-dot'></i></span>
                            <input type="text" className="form-control" name="provincia" placeholder="Provincia" onChange={handleChange} value={form.provincia || ''} />
                        </div>
                    </div>
                </div>                           
                                   
               <button className="btn btn-success m-1" type="submit"><i className="fa-regular fa-floppy-disk"></i> Guardar</button> 
               <input className="btn btn-primary" type="reset" value="Limpiar" onClick={handleReset}/>
            </form>
        </div>
    )
};

export default UsuarioCrudForm;